import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./i18n/i18n";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/i18n";
import {
  translateMenu,
  translateOurStudio,
  translateMethodology,
  translateIconSection,
  translateBiography,
  translatePrices,
  translateContact,
} from "./utlities/translations";

translateMenu();
translateOurStudio();
translateMethodology();
translateIconSection();
translateBiography();
translatePrices();
translateContact();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);
